import { Pagination } from '../utils/pagination-hooks';
import React from 'react';
import { CustomSelect } from './CustomSelect';
import { useTranslation } from 'react-i18next';

export const PageSizeComponent = ({ pagination, itemsToShow }: { pagination: Pagination; itemsToShow: number[] }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { setPagination, setCurrentPage, pageSize } = pagination;
    const updatePagination = (e: string) => {
        setCurrentPage(1);
        setPagination({ pageSize: +e, pageStart: 0 });
    };
    const items: number[] = [];
    itemsToShow.forEach((item) => items.unshift(item));
    return (
        <div className='d-flex text-nowrap justify-content-start align-items-center text-center custom-select-container'>
            <p className='mb-0 px-2 fw-bold'>{t('itemsToShow')}</p>
            <CustomSelect updateValue={updatePagination} itemsToShow={items} customClass='page-size-select' defaultItem={pageSize.toString()}/>
        </div>
    );
};
